module.exports = __webpack_public_path__ + "static/media/spaceship.07c5ab29.png";